import {QueryClient} from '@tanstack/react-query';
import {cache} from 'react';

export const getQueryClientForHydrator = cache(() => new QueryClient());
